export default __webpack_public_path__ + "static/media/Blonde&Barbue.2c36f3ec.png";